import React from 'react';
import { twMerge } from 'tailwind-merge';

const imageFallbackSvg = `<svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="96" height="96" fill="#002F5F"/><g opacity="0.2"><path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M67.4989 47.9995C67.4989 37.23 58.7689 28.5 47.9995 28.5C37.23 28.5 28.5 37.23 28.5 47.9995C28.5 58.7689 37.23 67.4989 47.9995 67.4989C58.7689 67.4989 67.4989 58.7689 67.4989 47.9995" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M47.1221 37.7808V50.9154C43.4948 50.9154 40.5549 47.9755 40.5549 44.3482C40.5549 40.7207 43.4948 37.7808 47.1221 37.7808" fill="#1F2830"/><path fill-rule="evenodd" clip-rule="evenodd" d="M48.877 58.2186V45.084C52.5042 45.084 55.4441 48.0242 55.4441 51.6514C55.4441 55.2787 52.5042 58.2186 48.877 58.2186" fill="#1F2830"/><path fill-rule="evenodd" clip-rule="evenodd" d="M55.0677 40.8764C55.0677 39.1669 53.6818 37.7808 51.9723 37.7808C50.2625 37.7808 48.877 39.1669 48.877 40.8764C48.877 42.5859 50.2625 43.9717 51.9723 43.9717C53.6818 43.9717 55.0677 42.5859 55.0677 40.8764" fill="#1F2830"/><path fill-rule="evenodd" clip-rule="evenodd" d="M47.1221 55.1232C47.1221 53.4137 45.7363 52.0278 44.0268 52.0278C42.3173 52.0278 40.9314 53.4137 40.9314 55.1232C40.9314 56.8327 42.3173 58.2185 44.0268 58.2185C45.7363 58.2185 47.1221 56.8327 47.1221 55.1232" fill="#1F2830"/></g></svg>`;

const encodedFallbackSvg = `url("data:image/svg+xml,${encodeURIComponent(
  imageFallbackSvg
)}")`;

export default function ImageFallback({
  width,
  height,
  className,
  style,
}: {
  width: number;
  height: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const backgroundSize = width < 96 ? `${width}px ${height}px` : '96px 96px';
  return (
    <div
      className={twMerge('flex items-center justify-center', className)}
      style={{
        width,
        height,
        backgroundImage: encodedFallbackSvg,
        backgroundRepeat: 'repeat',
        backgroundSize,
        ...style,
      }}
      data-testid="image-fallback-icon"
    />
  );
}
